import { useAuthContext } from '@/contexts/auth-context';

/**
 * Accounts that count Source metrics in calendar days at each opening's location.
 * The UI then sends dates rather than browser-offset instants, and "Last N days"
 * covers N calendar days.
 */
const LOCAL_DATE_RANGES_FLAG = 'source-location-timezone-ranges';

export function useLocalDateRanges(): boolean {
  const { whoami } = useAuthContext();

  return whoami?.feature_flags?.[LOCAL_DATE_RANGES_FLAG] === true;
}
